import { useEffect, useState } from "react";
import Markdown from "markdown-to-jsx";
import dynamic from "next/dynamic";
import DOMPurify from "isomorphic-dompurify";
import { useInView } from "react-cool-inview";

// const DynamicMap = dynamic(() =>
//   import("components/maps/DynamicMap/DynamicMap")
// );
import DynamicMap from "components/maps/DynamicMap/DynamicMap";
const MapMarker = dynamic(() => import("components/maps/MapMarker/MapMarker"));

import styles from "./LocationSection.module.scss";

const LocationSection = ({ experience, mapImage }) => {
  const [experienceGeoJSON, setExperienceGeoJSON] = useState({
    type: "FeatureCollection",
    features: [],
  });
  const { metadata, location } = experience;
  const { lngLat, country, city, description, cities } = location;

  const { lng, lat, zoom } = lngLat;

  const { observe, inView } = useInView({
    unobserveOnEnter: true,
  });

  useEffect(() => {
    // setExperienceGeoJSON({
    //   type: "FeatureCollection",
    //   features: [],
    // });

    cities?.forEach((cityItem, index) => {
      const markerElement =
        cityItem?.lng && cityItem?.lat ? (
          <MapMarker
            longitude={cityItem?.lng}
            latitude={cityItem?.lat}
            iconName="WhereNextLogo"
            key={`${cityItem?.lng}-${cityItem?.lat}-${index}`}
          />
        ) : null;

      const geoJSONObject = {
        type: "Feature",
        id: experience?.id,
        geometry: {
          type: "Point",
          coordinates: [cityItem?.lng, cityItem?.lat],
        },
        properties: {
          id: experience?.id,
          name: cityItem?.name,
          markerElement: markerElement,
        },
      };

      setExperienceGeoJSON((previous) => {
        const next = { ...previous };

        if (
          previous?.features &&
          previous.features.find((feature) => feature.id === geoJSONObject.id)
        ) {
          return previous;
        }

        next.features.push(geoJSONObject);
        next.features = Array.from(new Set(next?.features));

        return next;
      });

      // setExperienceGeoJSON((previous) => {
      //   previous.features = previous?.features
      //     ? Array.from(new Set([...previous?.features, feature]))
      //     : (previous.features = [feature]);

      //   return previous;
      // });
    });
  }, [cities, experience?.id]);

  // console.log(experienceGeoJSON);

  return (
    <>
      <div className={`${styles.locationInformationContainer}`}>
        <div className={`${styles.cityCountry}`}>
          <span>
            {city}, {country.countryName}
          </span>
        </div>
        <div className={`${styles.description}`}>
          {description && (
            <Markdown>{DOMPurify.sanitize(description)}</Markdown>
          )}
        </div>
      </div>
      <div ref={observe} className={`${styles.mapWrapper}`}>
        {lng && lat && zoom && inView && (
          <DynamicMap
            lat={cities[0]?.lat ?? lat}
            lng={cities[0]?.lng ?? lng}
            zoom={zoom}
            showMarkers={true}
            showSpiderfier={false}
            // popupInfo={popupInfo}
            // handlePopupClose={handlePopupClose}
            geoJSON={experienceGeoJSON}
            // markers={mapMarkers}
            // mapSourceID="destination-map"
          />
          // <StaticMap
          //   lat={lat}
          //   lng={lng}
          //   zoom={zoom}
          //   mapImage={mapImage}
          //   width={800}
          //   height={500}
          // />
        )}
      </div>
    </>
  );
};

export default LocationSection;
